export default "__VITE_ASSET__fd4b3997__"